import Modal from '../../../components/UI/Modals/Modal';
import classes from './ConfirmPaymentModal.module.css';
import PrimaryButtonV2 from '../../../components/UI/Buttons/PrimaryButtonV2';
import Spinner from '../../../components/UI/Spinner/Spinner';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  productPrice: number;
  confirmPayment: () => Promise<void>;
  isLoading: boolean;
};

const ConfirmPaymentModal: React.FC<Props> = ({
  isOpen,
  onClose,
  productPrice,
  confirmPayment,
  isLoading,
}) => {
  const { translations } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      containerPadding="20px"
      width="640px"
      maxWidth="90%"
      header={translations('payment')}
    >
      <div className={classes.container}>
        <div className={classes.price}>
          {productPrice ? `€ ${(productPrice / 100).toFixed(2)}` : '€ 0.00'}{' '}
        </div>
        <div className={classes.text}>
          {translations('complete.the.remaining.amount.on.your.cashier.system')}
        </div>
        {isLoading ? (
          <Spinner />
        ) : (
          <PrimaryButtonV2
            onClick={confirmPayment}
            text={translations('button.confirm')}
            disabled={false}
            containerStyle={{
              marginRight: 10,
            }}
            buttonStyle={{
              height: 60,
              padding: 10,
              borderRadius: 6,
              fontSize: 18,
              minWidth: 273,
            }}
          />
        )}
      </div>
    </Modal>
  );
};
export default ConfirmPaymentModal;
